import React from "react";
import moment from "moment";
import styled from "styled-components";
import Stars from "react-stars";

export default ({ items }) => (
  <Wrap>
    <Top className="flex">
      {/* <Title>34 Reviews</Title>
      <div className="ml-auto">
        <StarsWrap>
          <Stars
            count={5}
            size={24}
            value={5}
            edit={false}
            color2={"#333333"}
          />
        </StarsWrap>
      </div> */}
    </Top>
    <List>
      {items
        .filter(item => item.shared)
        .map((item, i) => (
          <Review
            key={i}
            name="Lauren"
            rating={item.rate.value}
            date={moment(item.created_at).format("MMM Do, YYYY")}
            text={item.general_feedback}
          />
        ))}
    </List>
  </Wrap>
);

const Review = ({ name, rating, date, text }) => (
  <ReviewWrap>
    <ReviewLeft>
      <Stars
        count={5}
        size={20}
        value={rating}
        edit={false}
        color2={"#f76267"}
      />
      <ReviewDate>{date}</ReviewDate>
    </ReviewLeft>
    <ReviewRight>{text}</ReviewRight>
  </ReviewWrap>
);

const List = styled.div``;

const ReviewWrap = styled.div`
  padding: 2.5rem;
  background-color: #fff;
  margin-bottom: 1rem;
  display: flex;
  &:last-child {
    margin-bottom: 0;
  }
  @media (max-width: 680px) {
    padding: 1rem;
    flex-direction: column;
  }
`;

const ReviewName = styled.div`
  font-size: 1.2rem;
  margin-bottom: 0.25rem;
`;

const ReviewLeft = styled.div`
  margin-right: 3rem;
  @media (max-width: 680px) {
    margin-right: unset;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
  }
`;

const ReviewRight = styled.div`
  flex: 1;
  flex-shrink: 0;
`;

const ReviewDate = styled.div`
  margin-top: 0.25rem;
  color: #adadad;
`;

const Top = styled.div`
  margin-bottom: 2rem;
  @media (max-width: 680px) {
    margin-bottom: 1rem;
  }
`;

const Wrap = styled.div`
  font-family: "CircularStd-Book", sans-serif;
  margin-bottom: 3rem;
`;

const Title = styled.div`
  color: #a1a19f;
  font-size: 1.8rem;
  @media (max-width: 680px) {
    font-size: 1rem;
  }
`;

const StarsWrap = styled.div`
  span {
    margin: 0 0.25rem;
  }
`;



// WEBPACK FOOTER //
// ./src/components/common/candidate/ScheduleCall/components/Reviews/index.js